import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PermissionObjectType',
    props: {
        type: null
    },
    setup(__props) {
        const props = __props;
        const typeTitle = computed(() => {
            if (props.type == "history") {
                return "History";
            }
            else if (props.type == "historyDataset") {
                return "Dataset";
            }
            else {
                return "Workflow";
            }
        });
        return { __sfc: true, props, typeTitle };
    }
});
